import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { IAddTenant, IStoreCreate } from "@/types/requests";
import type { IStoreDetailResponse, IStoreResponse } from "@/types/response";

class StoreService extends BaseHttp {
  async getStores(pageNumber: number, pageSize: number, searchTerm: string) {
    const { data } = await this.get<IStoreResponse>(
      "",
      { pageNumber, pageSize, searchTerm },
      { requestKey: "getStores" }
    );
    return data;
  }
  async getStoreById(id: string) {
    const { data } = await this.get<IStoreDetailResponse>(
      `/${id}`,
      {},
      { requestKey: "getStoreById" }
    );
    return data;
  }
  async createStore(body: IStoreCreate) {
    const { success, error } = await this.post<string>("", body, {
      requestKey: "createStore",
    });
    return { success, error };
  }
  async deleteStore(id: string) {
    const { success, error } = await this.delete<string>(
      `/${id}`,
      {},
      { requestKey: "deleteStore" }
    );
    return { success, error };
  }
  async removeTenant(id: string, tenantId: string, exitDate: string) {
    const { success, error } = await this.delete<string>(
      `/${id}/tenant/${tenantId}?exitDate=${exitDate}`,
      {},
      { requestKey: "removeTenant" }
    );
    return { success, error };
  }
  async addTenant(id: string, body: IAddTenant) {
    const { data, success, error } = await this.post<string>(
      `/${id}/tenant`,
      body,
      {
        requestKey: "addTenant",
      }
    );
    return { data, success, error };
  }
}

export default new StoreService(apiGwClient, "/api/v1/stores");
